import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "positions-container" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = { class: "positions-content" }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = {
  key: 1,
  class: "pagination-container"
}

import { ref, onMounted, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { usePositionStore } from '@/store/positionStore';
import type { Position } from '@/types/position';
import PositionItem from '@/components/position/PositionItem.vue';
import PositionForm from '@/components/position/PositionForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PositionsView',
  setup(__props) {

const router = useRouter();
const positionStore = usePositionStore();

const positions = ref<Position[]>([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(12);
const searchQuery = ref('');
const dialogVisible = ref(false);
const isEdit = ref(false);
const currentPosition = ref<Partial<Position>>({});
const loading = ref(false);

onMounted(() => {
  loadPositions();
});

const loadPositions = async () => {
  try {
    await positionStore.queryPositions({
      page: currentPage.value,
      size: pageSize.value
    });
    positions.value = positionStore.positions;
    total.value = positionStore.total;
  } catch (error) {
    ElMessage.error('加载职位列表失败');
    console.error(error);
  }
};

const searchPositions = async () => {
  if (!searchQuery.value.trim()) {
    return loadPositions();
  }
  
  try {
    await positionStore.searchPositions({
      keyword: searchQuery.value,
      page: currentPage.value,
      size: pageSize.value
    });
    positions.value = positionStore.positions;
    total.value = positionStore.total;
  } catch (error) {
    ElMessage.error('搜索职位失败');
    console.error(error);
  }
};

const handleSizeChange = (size: number) => {
  pageSize.value = size;
  loadPositions();
};

const handleCurrentChange = (page: number) => {
  currentPage.value = page;
  loadPositions();
};

const showAddDialog = () => {
  isEdit.value = false;
  currentPosition.value = {
    applicationStatus: 'not_started',
    interviewStatus: 'not_scheduled',
    workType: 'full_time',
    priority: 2,
    salaryCurrency: 'CNY'
  };
  dialogVisible.value = true;
};

const handlePositionClick = (position: Position) => {
  router.push(`/resources/positions/${position.id}`);
};

const handleFormSubmit = async (position: Partial<Position>) => {
  try {
    if (isEdit.value && position.id) {
      await positionStore.updatePosition(position);
      ElMessage.success('职位更新成功');
    } else {
      await positionStore.createPosition(position);
      ElMessage.success('职位添加成功');
    }
    dialogVisible.value = false;
    loadPositions();
  } catch (error) {
    ElMessage.error(isEdit.value ? '更新职位失败' : '添加职位失败');
    console.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", null, "职位管理", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          placeholder: "搜索职位...",
          "prefix-icon": "Search",
          clearable: "",
          onClear: loadPositions,
          onKeyup: _withKeys(searchPositions, ["enter"]),
          class: "search-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: showAddDialog
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("添加职位")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positions.value, (position) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 8,
              lg: 6,
              key: position.id
            }, {
              default: _withCtx(() => [
                _createVNode(PositionItem, {
                  position: position,
                  onClick: ($event: any) => (handlePositionClick(position))
                }, null, 8, ["position", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (positions.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_empty, { description: "没有找到职位" })
          ]))
        : _createCommentVNode("", true),
      (total.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
              "page-size": pageSize.value,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
              "page-sizes": [12, 24, 36, 48],
              layout: "total, sizes, prev, pager, next",
              total: total.value,
              onSizeChange: handleSizeChange,
              onCurrentChange: handleCurrentChange
            }, null, 8, ["current-page", "page-size", "total"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      title: isEdit.value ? '编辑职位' : '添加职位',
      width: "60%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (dialogVisible.value)
          ? (_openBlock(), _createBlock(PositionForm, {
              key: 0,
              position: currentPosition.value,
              loading: loading.value,
              onSubmit: handleFormSubmit,
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (dialogVisible.value = false))
            }, null, 8, ["position", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})